import { ComposerOrganisationSelectInterface } from 'src/app/model/composer/composer-organisation-select-interface';
import { PtgInterface } from 'src/app/model/ptgs/ptg-interface';

/* Custom Modul for the Properties Panel */
export function ComposerSelect(options: {
    id: string;
    label: string;
    options: ComposerOrganisationSelectInterface[];
    currentlySelectedId: string;
}) {
    let optionsString = '';
    options.options.forEach(
        (element) =>
            (optionsString += createSelectOption(
                element,
                options.currentlySelectedId
            ))
    );

    /* Custom Event that gets triggered when an Element is added - Handled by ComposerChangeHandler */
    const customEvent =
        "{const customEvent = document.createEvent('HTMLEvents');" +
        "customEvent.initEvent('creatorSelectChanged', true, true);" +
        "customEvent.eventName = 'creatorSelectChanged';" +
        'event.target.dispatchEvent(customEvent);}';

    return {
        id: options.id,
        html:
            '<div><label data-value="label" ' +
            '></label><div><select style="width: 95%" id="' +
            options.id +
            '" onchange="' +
            customEvent +
            '">' +
            optionsString +
            '</select>',
        get: function (element, node) {
            return {
                label: options.label
            };
        }
    };
}

/* Creates the HTML Code for a Select Option */
function createSelectOption(
    option: ComposerOrganisationSelectInterface,
    currentlySelectedId: string
) {
    if (option.organisationId === parseInt(currentlySelectedId)) {
        return (
            "<option selected value='" +
            option.organisationId +
            "'>" +
            option.name +
            '</option>'
        );
    }
    return (
        "<option value='" +
        option.organisationId +
        "'>" +
        option.name +
        '</option>'
    );
}
